import moment from 'moment-timezone';

export const getTimezonesNames = (): string[] => moment.tz.names();
